import * as tslib_1 from "tslib";
import { AfterViewInit, OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { MachineService } from '@services';
import { unsubscribe } from '@utils/object.utils';
import UiValidators from '@validators';
import { BehaviorSubject, } from 'rxjs';
import { finalize, map, } from 'rxjs/operators';
var RuntimeEditModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RuntimeEditModalComponent, _super);
    function RuntimeEditModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._machineService = _this._injector.get(MachineService);
        _this._appState = _this._injector.get(AppStateFacade);
        return _this;
    }
    RuntimeEditModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form = this._injector.get(FormBuilder).group({
            'runtimes': [this.context.data.nonProductionSlots],
        });
        this.licenseInfo$ = this._appState.user.license.value$
            .pipe(map(function (license) {
            var licenseKey = _this.context.additionalData === 'Unattended' ?
                'unattended' :
                'nonProduction';
            return {
                available: Math.max(0, license.allowed[licenseKey] - license.used[licenseKey]),
                total: license.allowed[licenseKey],
            };
        }));
    };
    RuntimeEditModalComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // set the max dynamically
        this._validatorSub = this.licenseInfo$.subscribe(function (licenseInfo) {
            _this.form.get('runtimes').setValidators([
                Validators.required,
                UiValidators.range(1, licenseInfo.total),
            ]);
            _this.form.get('runtimes').updateValueAndValidity();
            _this._cd.detectChanges();
        });
    };
    RuntimeEditModalComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._validatorSub);
    };
    RuntimeEditModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.form.invalid ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        var value = Number.parseInt(this.form.get('runtimes').value, 10);
        var payload = {};
        if (this.context.additionalData === 'Unattended') {
            payload.unattendedSlots = value;
        }
        else {
            payload.nonProductionSlots = value;
        }
        this._machineService.patch(this.context.data.id, payload)
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            _this._dialogRef.close({
                type: 2 /* Update */,
            });
        });
    };
    return RuntimeEditModalComponent;
}(UiModalComponent));
export { RuntimeEditModalComponent };
